export const secondaryColors = [
  {
    name: 'tema_verde',
    desc: 'Verde',
    hex: ['#011C16', '#022C22', '#0B4233', '#064E3B'],
  },
  {
    name: 'tema_amarillo',
    desc: 'Amarillo',
    hex: ['#2D1707', '#422006', '#5B330E', '#713F12'],
  },
  {
    name: 'tema_cian',
    desc: 'Cian',
    hex: ['#0F172A', '#083344', '#1B4554', '#164E63'],
  },
  {
    name: 'tema_azul',
    desc: 'Azul',
    hex: ['#0D0F32', '#0C1A4A', '#142E79', '#1E3A8A'],
  },
  {
    name: 'tema_purpura',
    desc: 'Púrpura',
    hex: ['#110F2C', '#1E1B4B', '#272465', '#322F6E'],
  },
  {
    name: 'tema_rojo',
    desc: 'Rojo',
    hex: ['#1D0303', '#450A0A', '#671717', '#7F1D1D'],
  },
  {
    name: 'tema_gris',
    desc: 'Gris',
    hex: ['#17202C', '#1F2937', '#2D3C51', '#4C586C'],
  },
];
